import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { provideHttpClient, withInterceptorsFromDi, HttpClientModule, withXhr } from '@angular/common/http'; // Ensure this is imported
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { AngularMaterialModule } from '../angular-material/angular-material.module';
import { BootstrapeModule } from '../bootstrape/bootstrape.module';
import { GroupClientAccountTableComponent } from './group-client-account-table/group-client-account-table.component';
import { ConfirmDialogComponent } from './confirm-dialog/confirm-dialog.component';
import { ClearOnNoDirective } from './clear-on-no.directive';




@NgModule({
  declarations: [
    GroupClientAccountTableComponent,
    ConfirmDialogComponent,
    ClearOnNoDirective
  ],
  imports: [
    CommonModule,
   
    FormsModule,
    ReactiveFormsModule,
    AngularMaterialModule,
    BootstrapeModule,
    HttpClientModule,
   
  ],
  exports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    AngularMaterialModule,
    BootstrapeModule,
    HttpClientModule,
    GroupClientAccountTableComponent,
    ConfirmDialogComponent,
    ClearOnNoDirective
  ],
  providers: [provideHttpClient(withXhr(), withInterceptorsFromDi())],
})
export class SharedModule { }
